import React, { useCallback, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { RHFTextField } from '../../components/hook-form';
import { toast } from 'react-toastify';
import useCommonDetails from '../../hooks/useCommonDetails';
import PAGE_ROUTES, {
  API_ROUTES,
  permissions,
  UserPermissions,
} from '../../utils/constant';
import HttpService from '../../hooks/Https-services';
import { useRouter } from '../../hooks/use-router';
import { getCurrentAuth, setAuth } from '../../hooks/http-server';
import ClockInOutLog from '../../components/ClockInOutLog';
import CachedIcon from '@mui/icons-material/Cached';
import parentCommonDetails from '../../hooks/parentComminDetails';
import { signOut } from 'firebase/auth';

export default function MyAccount() {
  const router = useRouter();
  const [childUser, setChildUser] = useState<any>([]);
  const currentUserInfo = useCommonDetails();
  const parentUserInfo = parentCommonDetails();
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string()
      .required('Email is required')
      .email('Email must be a valid email address'),
  });
  const [defaultValue, setDefaultValue] = useState({
    name: '',
    email: '',
  });
  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues: defaultValue,
  });

  const {
    handleSubmit,
    formState: { isSubmitting, errors },
  } = methods;
  const getMyDetails = useCallback(async () => {
    try {
      const res = await HttpService.get(API_ROUTES.UserMe);

      methods.reset({
        ...defaultValue,
        name: res.data.data.name,
        email: res.data.data.email,
      });
    } catch (error) {}
  }, []);
  useEffect(() => {
    getMyDetails();
  }, [getMyDetails]);
  const onSubmit = handleSubmit(async (data) => {
    const info = {
      email: data.email,
      name: data.name,
    };

    try {
      await HttpService.patch(API_ROUTES.editProfile, info).then((res) => {
        setAuth({
          Email: res.data.data.email || '',
          Name: res.data.data.name || '',
        });
      });
      toast.success('Update Successfully', {
        position: 'bottom-right',
      });
      router.push(PAGE_ROUTES.GAMES);
    } catch (error: any) {
      console.error('Error in Edit Profile:', error);
    }
  });

  const fetchUserById = React.useCallback(async () => {
    try {
      const response = parentUserInfo
        ? await HttpService.getParent(API_ROUTES.childUserList)
        : await HttpService.get(API_ROUTES.childUserList);
      setChildUser(response.data.data);
    } catch (error: any) {
      console.error('Error fetching teams list:', error);
    }
  }, []);
  React.useEffect(() => {
    fetchUserById();
  }, [fetchUserById]);
  const SwitchUser = async (id: any) => {
    const info = { userId: id };
    try {
      const auth = getCurrentAuth();
      const parentIdToken: any = auth.Token;
      const parentRefreshToken: any = auth.RefreshToken;

      if (parentUserInfo && parentUserInfo.userId == id) {
        localStorage.removeItem('auth');
        localStorage.removeItem('refreshToken');
        setAuth({
          Token: auth.parent_accessToken,
          RefreshToken: auth.parent_refreshToken,
          Email: parentUserInfo.email || '',
          Name: parentUserInfo.name || '',
          roleId: parentUserInfo.roleId || '',
          id: parentUserInfo.userId || '',
        });

        window.location.reload();
        return;
      }
      const response = parentUserInfo
        ? await HttpService.postParent(API_ROUTES.switchUser, info)
        : await HttpService.post(API_ROUTES.switchUser, info);
      if (response.data.data) {
        const idToken = response.data.data.authTokens.accessToken;
        const refreshToken = response.data.data.authTokens.refreshToken;
        const info = {
          Token: idToken,
          RefreshToken: refreshToken,
          Email: response.data.data.email || '',
          Name: response.data.data.name || '',
          Phone: response.data.data.phoneNo || '',
          roleId: response.data.data.roleId || '',
          id: response.data.data.id || '',
        };
        if (
          UserPermissions[currentUserInfo?.isDesabled]?.includes(
            permissions.PARENTUSER
          ) ||
          UserPermissions[currentUserInfo?.isDesabled]?.includes(
            permissions.MIDDELE
          )
        ) {
          setAuth({
            ...info,
            parent_accessToken: parentIdToken,
            parent_refreshToken: parentRefreshToken,
          });
        } else if (parentUserInfo) {
          setAuth({
            ...info,
            parent_accessToken: auth.parent_accessToken,
            parent_refreshToken: auth.parent_refreshToken,
          });
        }
        window.location.reload();
      }
    } catch (error: any) {
      console.error('Error fetching teams list:', error);
    }
  };
  return (
    <>
      <Box sx={{ margin: 2 }}>
        <FormProvider {...methods}>
          <form onSubmit={onSubmit}>
            <Grid container spacing={3}>
              <Grid xs={12} md={12}>
                <Card sx={{ p: 3 }}>
                  <Box
                    rowGap={3}
                    columnGap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(2, 1fr)',
                    }}
                  >
                    <RHFTextField name="name" label="Name" />
                    <RHFTextField disabled name="email" label="Email Address" />
                  </Box>

                  <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      loading={isSubmitting}
                    >
                      {'Save Changes'}
                    </LoadingButton>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </Box>
      {(UserPermissions[currentUserInfo?.isDesabled]?.includes(
        permissions.PARENTUSER
      ) ||
        UserPermissions[currentUserInfo?.isDesabled]?.includes(
          permissions.MIDDELE
        ) ||
        UserPermissions[parentUserInfo?.isDesabled]?.includes(
          permissions.PARENTUSER
        ) ||
        UserPermissions[parentUserInfo?.isDesabled]?.includes(
          permissions.MIDDELE
        )) && (
        <Box>
          <Card sx={{ p: 3, marginBottom: 2 }}>
            {childUser?.length > 0 ? (
              childUser?.map((item: any, index: number) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    gap: 1,
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  {item.id === currentUserInfo.userId ? (
                    <Box
                      sx={{
                        height: '15px',
                        width: '15px',
                        borderRadius: '15px',
                        margin: '0 10px',
                        color: 'lightgreen',
                        backgroundColor: 'lightgreen',
                      }}
                    ></Box>
                  ) : (
                    <Tooltip title="Switch User">
                      <IconButton
                        aria-label="Switch User"
                        size="small"
                        onClick={() => SwitchUser(item.id)}
                      >
                        <CachedIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  <Typography variant="h6">
                    {item.name} ({item.middleName})
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="h6">No Chid User Found</Typography>
            )}
            {parentUserInfo && (
              <Box sx={{ display: 'flex', gap: 1, flexDirection: 'row' }}>
                <Tooltip title="Switch User">
                  <IconButton
                    aria-label="Switch User"
                    size="small"
                    onClick={() => SwitchUser(parentUserInfo.userId)}
                  >
                    <CachedIcon />
                  </IconButton>
                </Tooltip>
                <Typography variant="h6">{parentUserInfo.name}</Typography>
              </Box>
            )}
          </Card>
        </Box>
      )}
      {/* {ROLE_MAP[currentUserInfo.roleId] !== 'admin' && */}
      <ClockInOutLog />
      {/* } */}
    </>
  );
}
